<div class="d-flex flex-column justify-content-start align-items-center h-100 w-100">

    <app-header-section
        class="w-100"
        [title]="headerTitle"
        [buttonText]="headerButtonText"
        [buttonIcon]="headerButtonIcon"
        [buttonUrl]="headerButtonUrl">
    </app-header-section>

    <div class="card d-flex flex-column justify-content-start align-items-stretch h-100 w-75 my-3">

        <app-spinner
            [isLoading]="isLoadingData"
            [isFullScreen]="false">
        </app-spinner>

        <app-tutor-edit *ngIf="!isLoadingData"
            class="h-100 p-3"
            [tutor]="tutor">
        </app-tutor-edit>

    </div>

</div>
